var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicDatadisplayTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 48.614,
    viewBox: "0 0 90 48.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_849",
    "data-name": "Rectangle 849",
    width: 90,
    height: 48.614,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_848",
    "data-name": "Rectangle 848",
    width: 90,
    height: 48.615,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_836",
    "data-name": "Rectangle 836",
    width: 90,
    height: 3.957,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_837",
    "data-name": "Rectangle 837",
    width: 90,
    height: 3.95,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_847",
    "data-name": "Rectangle 847",
    width: 90,
    height: 2.94,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1437",
    "data-name": "Group 1437",
    opacity: 0.752
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1402",
    "data-name": "Group 1402",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1401",
    "data-name": "Group 1401",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1400",
    "data-name": "Group 1400",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14171",
    "data-name": "Path 14171",
    d: "M88.112,0H1.895A1.892,1.892,0,0,0,0,1.895v5.88H90V1.895A1.89,1.89,0,0,0,88.112,0M58.972,4.894a1.422,1.422,0,0,1-1.007.419H32.034a1.426,1.426,0,0,1,0-2.852H57.966a1.424,1.424,0,0,1,1.007,2.433",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1375",
    "data-name": "Group 1375",
    transform: "translate(0 8.474)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1374",
    "data-name": "Group 1374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1373",
    "data-name": "Group 1373",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14172",
    "data-name": "Path 14172",
    d: "M0,16.077H30.867V12.12H0Zm19.793-.986H11.074a.993.993,0,1,1,0-1.986h8.718a.993.993,0,0,1,0,1.986",
    transform: "translate(0 -12.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14173",
    "data-name": "Path 14173",
    d: "M45.15,16.077H59.238V12.12H45.15Zm9.319-.986H49.918a.993.993,0,0,1,0-1.986H54.47a.993.993,0,1,1,0,1.986",
    transform: "translate(-13.584 -12.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14174",
    "data-name": "Path 14174",
    d: "M66.3,16.077H80.381V12.12H66.3Zm9.319-.986H71.068a.993.993,0,1,1,0-1.986h4.551a.993.993,0,1,1,0,1.986",
    transform: "translate(-19.947 -12.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14175",
    "data-name": "Path 14175",
    d: "M87.44,16.077h14.088V12.12H87.44Zm9.32-.986H92.208a.993.993,0,1,1,0-1.986H96.76a.993.993,0,0,1,0,1.986",
    transform: "translate(-26.307 -12.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14176",
    "data-name": "Path 14176",
    d: "M108.59,16.077h14.081V12.12H108.59Zm9.32-.986h-4.558a.993.993,0,1,1,0-1.986h4.558a.993.993,0,1,1,0,1.986",
    transform: "translate(-32.671 -12.12)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1378",
    "data-name": "Group 1378",
    transform: "translate(0 13.13)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1377",
    "data-name": "Group 1377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1376",
    "data-name": "Group 1376",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14177",
    "data-name": "Path 14177",
    d: "M0,22.73H30.867V18.78H0Zm18.506-1.279H12.361a.7.7,0,0,1,0-1.4h6.145a.7.7,0,0,1,0,1.4",
    transform: "translate(0 -18.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14178",
    "data-name": "Path 14178",
    d: "M45.15,22.73H59.238V18.78H45.15ZM53.8,21.451H50.589a.7.7,0,0,1,0-1.4H53.8a.7.7,0,1,1,0,1.4",
    transform: "translate(-13.584 -18.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14179",
    "data-name": "Path 14179",
    d: "M66.3,22.73H80.381V18.78H66.3Zm8.648-1.279H71.739a.7.7,0,0,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-19.947 -18.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14180",
    "data-name": "Path 14180",
    d: "M87.44,22.73h14.088V18.78H87.44Zm8.648-1.279H92.879a.7.7,0,0,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-26.307 -18.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14181",
    "data-name": "Path 14181",
    d: "M108.59,22.73h14.081V18.78H108.59Zm8.648-1.279h-3.209a.7.7,0,1,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-32.671 -18.78)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1381",
    "data-name": "Group 1381",
    transform: "translate(0 17.779)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1380",
    "data-name": "Group 1380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1379",
    "data-name": "Group 1379",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14182",
    "data-name": "Path 14182",
    d: "M0,29.38H30.867V25.43H0ZM18.506,28.1H12.361a.7.7,0,1,1,0-1.4h6.145a.7.7,0,1,1,0,1.4",
    transform: "translate(0 -25.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14183",
    "data-name": "Path 14183",
    d: "M45.15,29.38H59.238V25.43H45.15ZM53.8,28.1H50.589a.7.7,0,0,1,0-1.4H53.8a.7.7,0,1,1,0,1.4",
    transform: "translate(-13.584 -25.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14184",
    "data-name": "Path 14184",
    d: "M66.3,29.38H80.381V25.43H66.3ZM74.948,28.1H71.739a.7.7,0,0,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-19.947 -25.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14185",
    "data-name": "Path 14185",
    d: "M87.44,29.38h14.088V25.43H87.44ZM96.088,28.1H92.879a.7.7,0,0,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-26.307 -25.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14186",
    "data-name": "Path 14186",
    d: "M108.59,29.38h14.081V25.43H108.59Zm8.648-1.279h-3.209a.7.7,0,1,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-32.671 -25.43)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1384",
    "data-name": "Group 1384",
    transform: "translate(0 22.429)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1383",
    "data-name": "Group 1383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1382",
    "data-name": "Group 1382",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14187",
    "data-name": "Path 14187",
    d: "M0,36.03H30.867V32.08H0Zm18.506-1.279H12.361a.7.7,0,1,1,0-1.4h6.145a.7.7,0,1,1,0,1.4",
    transform: "translate(0 -32.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14188",
    "data-name": "Path 14188",
    d: "M45.15,36.03H59.238V32.08H45.15ZM53.8,34.751H50.589a.7.7,0,0,1,0-1.4H53.8a.7.7,0,1,1,0,1.4",
    transform: "translate(-13.584 -32.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14189",
    "data-name": "Path 14189",
    d: "M66.3,36.03H80.381V32.08H66.3Zm8.648-1.279H71.739a.7.7,0,0,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-19.947 -32.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14190",
    "data-name": "Path 14190",
    d: "M87.44,36.03h14.088V32.08H87.44Zm8.648-1.279H92.879a.7.7,0,0,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-26.307 -32.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14191",
    "data-name": "Path 14191",
    d: "M108.59,36.03h14.081V32.08H108.59Zm8.648-1.279h-3.209a.7.7,0,1,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-32.671 -32.08)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1387",
    "data-name": "Group 1387",
    transform: "translate(0 27.078)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1386",
    "data-name": "Group 1386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1385",
    "data-name": "Group 1385",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14192",
    "data-name": "Path 14192",
    d: "M0,42.68H30.867V38.73H0ZM18.506,41.4H12.361a.7.7,0,0,1,0-1.4h6.145a.7.7,0,0,1,0,1.4",
    transform: "translate(0 -38.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14193",
    "data-name": "Path 14193",
    d: "M45.15,42.68H59.238V38.73H45.15ZM53.8,41.4H50.589a.7.7,0,0,1,0-1.4H53.8a.7.7,0,1,1,0,1.4",
    transform: "translate(-13.584 -38.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14194",
    "data-name": "Path 14194",
    d: "M66.3,42.68H80.381V38.73H66.3ZM74.948,41.4H71.739a.7.7,0,0,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-19.947 -38.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14195",
    "data-name": "Path 14195",
    d: "M87.44,42.68h14.088V38.73H87.44ZM96.088,41.4H92.879a.7.7,0,0,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-26.307 -38.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14196",
    "data-name": "Path 14196",
    d: "M108.59,42.68h14.081V38.73H108.59Zm8.648-1.279h-3.209a.7.7,0,1,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-32.671 -38.73)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1390",
    "data-name": "Group 1390",
    transform: "translate(0 31.727)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1389",
    "data-name": "Group 1389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1388",
    "data-name": "Group 1388",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14197",
    "data-name": "Path 14197",
    d: "M0,49.33H30.867V45.38H0Zm18.506-1.279H12.361a.7.7,0,1,1,0-1.4h6.145a.7.7,0,1,1,0,1.4",
    transform: "translate(0 -45.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14198",
    "data-name": "Path 14198",
    d: "M45.15,49.33H59.238V45.38H45.15ZM53.8,48.051H50.589a.7.7,0,0,1,0-1.4H53.8a.7.7,0,1,1,0,1.4",
    transform: "translate(-13.584 -45.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14199",
    "data-name": "Path 14199",
    d: "M66.3,49.33H80.381V45.38H66.3Zm8.648-1.279H71.739a.7.7,0,0,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-19.947 -45.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14200",
    "data-name": "Path 14200",
    d: "M87.44,49.33h14.088V45.38H87.44Zm8.648-1.279H92.879a.7.7,0,0,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-26.307 -45.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14201",
    "data-name": "Path 14201",
    d: "M108.59,49.33h14.081V45.38H108.59Zm8.648-1.279h-3.209a.7.7,0,1,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-32.671 -45.38)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1393",
    "data-name": "Group 1393",
    transform: "translate(0 36.376)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1392",
    "data-name": "Group 1392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1391",
    "data-name": "Group 1391",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14202",
    "data-name": "Path 14202",
    d: "M0,55.979H30.867v-3.95H0ZM18.506,54.7H12.361a.7.7,0,1,1,0-1.4h6.145a.7.7,0,1,1,0,1.4",
    transform: "translate(0 -52.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14203",
    "data-name": "Path 14203",
    d: "M45.15,55.979H59.238v-3.95H45.15ZM53.8,54.7H50.589a.7.7,0,0,1,0-1.4H53.8a.7.7,0,1,1,0,1.4",
    transform: "translate(-13.584 -52.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14204",
    "data-name": "Path 14204",
    d: "M66.3,55.979H80.381v-3.95H66.3ZM74.948,54.7H71.739a.7.7,0,1,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-19.947 -52.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14205",
    "data-name": "Path 14205",
    d: "M87.44,55.979h14.088v-3.95H87.44ZM96.088,54.7H92.879a.7.7,0,0,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-26.307 -52.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14206",
    "data-name": "Path 14206",
    d: "M108.59,55.979h14.081v-3.95H108.59Zm8.648-1.279h-3.209a.7.7,0,1,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-32.671 -52.029)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1396",
    "data-name": "Group 1396",
    transform: "translate(0 41.025)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1395",
    "data-name": "Group 1395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1394",
    "data-name": "Group 1394",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14207",
    "data-name": "Path 14207",
    d: "M0,62.629H30.867v-3.95H0ZM18.506,61.35H12.361a.7.7,0,1,1,0-1.4h6.145a.7.7,0,1,1,0,1.4",
    transform: "translate(0 -58.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14208",
    "data-name": "Path 14208",
    d: "M45.15,62.629H59.238v-3.95H45.15ZM53.8,61.35H50.589a.7.7,0,1,1,0-1.4H53.8a.7.7,0,1,1,0,1.4",
    transform: "translate(-13.584 -58.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14209",
    "data-name": "Path 14209",
    d: "M66.3,62.629H80.381v-3.95H66.3Zm8.648-1.279H71.739a.7.7,0,1,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-19.947 -58.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14210",
    "data-name": "Path 14210",
    d: "M87.44,62.629h14.088v-3.95H87.44Zm8.648-1.279H92.879a.7.7,0,0,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-26.307 -58.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14211",
    "data-name": "Path 14211",
    d: "M108.59,62.629h14.081v-3.95H108.59Zm8.648-1.279h-3.209a.7.7,0,1,1,0-1.4h3.209a.7.7,0,1,1,0,1.4",
    transform: "translate(-32.671 -58.679)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1399",
    "data-name": "Group 1399",
    transform: "translate(0 45.675)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1398",
    "data-name": "Group 1398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1397",
    "data-name": "Group 1397",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14212",
    "data-name": "Path 14212",
    d: "M0,65.329v1.045a1.894,1.894,0,0,0,1.895,1.895H30.867v-2.94Z",
    transform: "translate(0 -65.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_844",
    "data-name": "Rectangle 844",
    width: 14.088,
    height: 2.94,
    transform: "translate(31.566 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_845",
    "data-name": "Rectangle 845",
    width: 14.081,
    height: 2.94,
    transform: "translate(46.353 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_846",
    "data-name": "Rectangle 846",
    width: 14.088,
    height: 2.94,
    transform: "translate(61.133 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14213",
    "data-name": "Path 14213",
    d: "M108.59,65.329v2.94h12.186a1.894,1.894,0,0,0,1.895-1.895V65.329Z",
    transform: "translate(-32.671 -65.329)",
    fill: "#fff"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicDatadisplayTable);
export default __webpack_public_path__ + "static/media/graphic-datadisplay-table.685eac8c41ca53d9926222352b2ff8ac.svg";
export { ForwardRef as ReactComponent };